import React from 'react';

import { useDispatch, useSelector } from 'react-redux';
import { Notification, STATUS_TYPES } from 'dyl-components';

import contactActions from 'actions/contact';
import pipelineActions from 'actions/pipeline';
import ProfileStages from 'shared/ProfileStages';
import contactSequenceActions from 'actions/contact_sequence';
import sequencesActions from 'actions/sequences';
import sequenceTasksActions from 'actions/sequence_tasks';
import ConversionControls from './ConversionControls';
import customerPipelineActions from 'actions/customer_pipeline';
import { StringUtils } from 'utils';

const StagesSectionContainer = (({
    id,
    assignees
}) => {
    const { parent_account, current_stage, isTransitioningPipeline, contactSequenceTasks, selectedSequenceId, userAuthTimezone } = useSelector(state => {
        return {
            isTransitioningPipeline: state.pipeline.isTransitioningPipeline || state.contact_sequence.isRemovingSequence || state.sequences.isAddingContactToSequence || state.customer_pipeline.accountBeingUpdated,

            parent_account: state.contact.account,
            current_stage: state.contact.current_stage,

            contactSequenceTasks: state.sequence_tasks.selectedSequenceTasks,
            selectedSequenceId: state.sequence_tasks.selectedSequenceId,
            userAuthTimezone: state.auth.timezone
        }
    });

    const { id: account_id } = parent_account || {};

    const dispatch = useDispatch();

    const isDyl = useSelector(state => state.auth.dyl_employee);
    const fund_type = useSelector(state => state.contact.account?.fund_type);

    const pipeline_id = current_stage?.pipeline_id;

    const onTransitionPipeline = async (stage_name) => {
        const newStage = (current_stage.stages?.map(({ id, name, sequence_id }) => {
            return {
                id,
                content: name,
                sequence_id
            }
        }) || []).find(stage => stage.content === stage_name);
        if (Number(current_stage.pipeline_stage_id) === Number(newStage.id)) {
            return;
        }
        const areSequenceTasksCompleted = contactSequenceTasks.length === 0 || contactSequenceTasks.every(task => task.status === 'complete' || task.status === 'canceled');
        try {
            if (current_stage?.account_stage !== "customer") {
                await dispatch(pipelineActions.transition(pipeline_id, {
                    account_id: account_id,
                    pipeline_stage_id: newStage.id,
                    person_id: id
                }, { sequence_done: areSequenceTasksCompleted }));
                if (selectedSequenceId) {
                    await dispatch(contactSequenceActions.removeFromContact(id));
                }
                if (newStage.sequence_id) {
                    await dispatch(sequencesActions.addToSequence({ contact_id: id, timezone: userAuthTimezone, owner_id: assignees?.owner_id }, null, newStage.sequence_id));
                }
            } else {
                await dispatch(customerPipelineActions.update(account_id, {
                    pipeline_stage_id: Number(newStage.id),
                    person_id: id,
                    pipeline_id: pipeline_id,
                    sequence_id: newStage?.sequence_id || null
                }, { action: 'transition' }));
            }
            Notification.alert(`Successfully updated stage!`, STATUS_TYPES.SUCCESS);
            dispatch(contactActions.readContact(id));
            dispatch(sequenceTasksActions.readContactTasks(id));
        } catch (e) {
            console.log(e);
            Notification.alert('Failed to update stage', STATUS_TYPES.ERROR);
        }
    }

    return (
        <div>
            <ProfileStages
                current_stage={current_stage}
                onTransitionPipeline={onTransitionPipeline}
                isTransitioningPipeline={isTransitioningPipeline}
                fund_type={isDyl ? `${fund_type !== 'funded' ? StringUtils.capitalize(fund_type) : ''}` : ''}
                assignees={assignees}
            />
        </div>
    );
});

const StagesSection = ({ id }) => {
    const contactIsAssociatedWithCustomerPipeline = useSelector(state => state.contact.account?.pipeline_person_id === Number(state.contact.contact_id));
    const { current_stage, isReadingSequenceContactTasks } = useSelector(state => {
        return {
            isTransitioningPipeline: state.pipeline.isTransitioningPipeline || state.contact_sequence.isRemovingSequence || state.sequences.isAddingContactToSequence || state.customer_pipeline.accountBeingUpdated,
            current_stage: state.contact.current_stage,
            isReadingSequenceContactTasks: state.sequence_tasks.isReadingSequenceContactTasks
        }
    });
    const isDyl = useSelector(state => state.auth.dyl_employee);
    const fund_type = useSelector(state => state.contact.account?.fund_type);
    const contact = useSelector(state => state.contact.contact);

    return (
        <>
            {!contactIsAssociatedWithCustomerPipeline && (
                <div style={{ position: 'absolute', top: 0, right: 0 }}>
                    <ConversionControls />
                </div>
            )}
            {isReadingSequenceContactTasks ? (
                <ProfileStages
                    assignees={contact?.assignees}
                    current_stage={current_stage}
                    onTransitionPipeline={() => { }}
                    isTransitioningPipeline={isReadingSequenceContactTasks}
                    fund_type={isDyl ? `${fund_type !== 'funded' ? StringUtils.capitalize(fund_type) : ''}` : ''}
                />
            ) : (
                <StagesSectionContainer id={id} assignees={contact?.assignees} />
            )}
        </>
    )
}

export default StagesSection;
